import { ArtificialProposalResponse } from 'v2/models';
import { SearchResponseItemProps } from '../../SearchResponseItem';
import { ResponsesListItemType } from '../enums';
import { ResponsesListItem } from '../types';

export function mapSearchToResponseListItem(
  search: SearchResponseItemProps
): ResponsesListItem {
  return {
    type: ResponsesListItemType.RequestResponse,
    data: search,
  };
}

export function mapArtificialProposalResponseToResponseListItem(
  artificialProposalResponse: ArtificialProposalResponse
): ResponsesListItem {
  return {
    type: ResponsesListItemType.ArtificialProposalResponse,
    data: artificialProposalResponse,
  };
}
